import MegaMenu from './MegaMenu'

export default MegaMenu
